<template>
  <div class="usersDetail">
    <div class="userInfoTop">
      <div class="user_left">
        <!-- 个人 -->
        <!-- <img src="../../../assets/images/GroupLogo.png" alt="" /> -->
        <img :src="formData.headPortrait" alt="" />
        <!-- 企业 -->
        <!-- <img src="../../../assets/images/Group 1000001412 (1).png" alt="" /> -->
        <div class="userInfo">
          <h3 v-if="usersForm.userType == '0'">{{ formData.name }}</h3>
          <h3 v-if="usersForm.userType == '1'">{{ formData.companyName }}</h3>
          <div class="stateBox">
            <span class="phone">{{ formData.phone }}</span>
            <span class="state stateQ" v-if="usersForm.state == '1'">启用</span>
            <span class="state stateT" v-if="usersForm.state == '0'">停用</span>
          </div>
        </div>
      </div>
      <div class="user_right">
        <dic-button
          @buttonClick="editItem()"
          icon="icon-jr-icon-modify"
          permission="/company/update"
          text="编辑"
        />
        <el-button type="text" @click="editItem()">编辑</el-button>
      </div>
    </div>
    <div class="reasonState" v-if="formData.rejectReason">
      <i class="el-icon-warning"></i>
      <span>{{ formData.rejectReason }}</span>
    </div>
    <div
      class="userInfoBom"
      :style="
        formData.rejectReason
          ? 'height: calc(100vh - 64px - 40px - 10px - 128px - 80px - 14px - 48px)'
          : 'height: calc(100vh - 64px - 40px - 10px - 128px - 80px - 14px)'
      "
    >
      <el-form label-position="right" label-width="100px" v-if="reviewStatus != 3">
        <div class="basicInfoBox">
          <div class="basicInfo">
            <div class="title"><span></span><span>基本信息</span></div>
          </div>
          <!-- 个人 -->
          <div class="infoDetail" v-if="usersForm.userType == 0">
            <div>
              <el-form-item label="所在地点：">
                <span>{{ formData.userCountry }}</span>
                <span v-if="formData.userCountry && formData.userProvince">-</span>
                <span>{{ formData.userProvince }}</span>
                <span v-if="formData.userProvince && formData.userCity">-</span>
                <span>{{ formData.userCity }}</span>
              </el-form-item>
              <el-form-item label="邮箱：">{{ formData.mail }}</el-form-item>
              <el-form-item label="微信号：">{{ formData.weChat }}</el-form-item>
            </div>
            <div>
              <el-form-item label="真实姓名：">{{ formData.name }}</el-form-item>
              <el-form-item label="联系电话：">{{ formData.phone }}</el-form-item>
              <el-form-item label="擅长领域：" style="color: rgba(23, 117, 122, 0.85)">{{
                formData.technique
              }}</el-form-item>
            </div>
          </div>
          <!-- 企业 -->
          <div class="infoDetail" v-if="usersForm.userType == 1">
            <div>
              <el-form-item label="企业名称：">{{ formData.companyName }}</el-form-item>
              <el-form-item label="所在地点：">
                <span>{{ formData.userCountry }}</span>
                <span v-if="formData.userCountry && formData.userProvince">-</span>
                <span>{{ formData.userProvince }}</span>
                <span v-if="formData.userProvince && formData.userCity">-</span>
                <span>{{ formData.userCity }}</span>
              </el-form-item>
              <el-form-item label="邮箱：">{{ formData.mail }}</el-form-item>
              <el-form-item label="感兴趣领域：">{{ formData.interested }}</el-form-item>
            </div>
            <div>
              <el-form-item label="联系电话：">{{ formData.phone }}</el-form-item>
              <el-form-item label="联系人：">{{ formData.contacts }}</el-form-item>
              <el-form-item label="擅长领域：" style="color: rgba(23, 117, 122, 0.85)">{{
                formData.technique
              }}</el-form-item>
            </div>
          </div>
        </div>
        <!-- 个人 -->
        <div class="identityBox" v-if="usersForm.userType == 0">
          <div class="basicInfo identity">
            <div class="title"><span></span><span>身份认证</span></div>
          </div>
          <div class="infoDetail">
            <div>
              <el-form-item label="身份证正面：">
                <!-- <img src="../../../assets/images/Group 2424.png" alt="" /> -->
                <!-- <img :src="formData.idCardFront" alt="" /> -->
                <el-image
                  style="width: 124px; height: 84px"
                  :src="formData.idCardFront"
                  :preview-src-list="idCardFrontList"
                >
                </el-image>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="身份证反面：">
                <!-- <img src="../../../assets/images/Group 2429.png" alt="" /> -->
                <!-- <img :src="formData.idCardReverse" alt="" /> -->
                <el-image
                  style="width: 124px; height: 84px"
                  :src="formData.idCardReverse"
                  :preview-src-list="idCardReverseList"
                >
                </el-image>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 企业 -->
        <div class="identityBox" v-if="usersForm.userType == 1">
          <div class="basicInfo identity">
            <div class="title"><span></span><span>信息认证</span></div>
          </div>
          <div class="infoDetail">
            <div>
              <el-form-item label="营业执照：">
                <!-- <img src="../../../assets/images/yinyezhizhao.png" alt="" /> -->
                <img :src="formData.businessLicense" alt="" />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="accountBox">
          <div class="basicInfo account">
            <div class="title"><span></span><span>账户信息</span></div>
          </div>
          <div class="infoDetail account row">
            <el-form-item label="开户行支行："> {{ formData.openingBank }} </el-form-item>
            <el-form-item label="银行卡号："> {{ formData.bankCar }} </el-form-item>
          </div>
        </div>
        <div class="commitTime">
          <span>提交时间：{{ formData.createTime }}</span>
          <span>新增时间：{{ formData.createTime }}</span>
        </div>
      </el-form>
      <div v-if="reviewStatus == 3" class="empty">
        <img src="../../../assets/images/Group 1142813967.png" alt="" />
        <span style="color: rgba(153, 153, 153, 1)">该用户还未上传提交个人信息</span>
      </div>
    </div>
    <div class="operation">
      <el-button type="primary" plain @click="backSuperior">返回上级</el-button>
    </div>
    <!-- 编辑用户弹窗 -->
    <el-dialog
      title="编辑用户"
      :visible.sync="dialogVisibleedit"
      width="40%"
      :before-close="edithandleClose"
    >
      <div style="padding: 30px">
        <el-form
          ref="usersForm"
          :rules="usersFormRules"
          :model="usersForm"
          label-position="right"
          label-width="100px"
        >
          <!-- <el-form-item label="用户类型：" prop="userType">
            <el-radio-group v-model="usersForm.userType" aria-disabled="true">
              <el-radio label="0" disabled>个人用户</el-radio>
              <el-radio label="1" disabled>企业用户</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="display: flex">
            <el-form-item
              label="用户名："
              prop="name"
              v-if="usersForm.userType == '0' || !usersForm.userType"
            >
              <el-input v-model="usersForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item
              label="企业名称："
              prop="companyName"
              v-if="usersForm.userType == '1' || !usersForm.userType"
            >
              <el-input v-model="usersForm.companyName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone" style="margin-left: 40px">
              <el-input v-model="usersForm.phone" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between">
            <el-form-item label="是否启用：">
              <el-switch
                v-model="usersForm.state"
                active-color="rgb(77, 167, 91)"
                inactive-color="#DCDFE6"
                active-value="1"
                inactive-value="0"
                active-text="启用"
                :width="60"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label="默认密码：" style="width: 50%"> admin </el-form-item>
          </div> -->

          <!-- 1 -->
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="用户类型：" prop="userType">
              <el-radio-group v-model="usersForm.userType" aria-disabled="true">
                <el-radio label="0" disabled>个人用户</el-radio>
                <el-radio label="1" disabled>企业用户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否启用：" style="width: 44%">
              <el-switch
                v-model="usersForm.state"
                active-color="rgba(23, 117, 122, 1)"
                inactive-color="#DCDFE6"
                active-value="1"
                inactive-value="0"
                active-text="启用"
                :width="60"
              >
              </el-switch>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item
              label="用户名："
              prop="name"
              v-if="usersForm.userType == '0' || !usersForm.userType"
            >
              <el-input v-model="usersForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item
              label="企业名称："
              prop="companyName"
              v-if="usersForm.userType == '1' || !usersForm.userType"
            >
              <el-input v-model="usersForm.companyName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="企业名称：" prop="companyName" v-if="usersForm.userType == '1'">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.companyName"
                  placeholder="请输入"
                  style="width: 187px"
                ></el-input>
                <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.companyName">{{
                  msgCompanyTips
                }}</span>
              </div>
            </el-form-item>
            <div style="display: flex; flex-direction: column; width: 44%">
              <el-form-item label="性别：" prop="gender">
                <el-radio-group v-model="usersForm.gender">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="英文名：">
              <div style="display: flex; flex-direction: column">
                <el-input v-model="usersForm.nameEnglish" placeholder="请输入"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="邮箱：" prop="mail" style="width: 44%">
              <el-input
                v-model="usersForm.mail"
                placeholder="请输入"
                style="width: 187px"
              ></el-input>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="联系电话：" prop="phone">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.phone"
                  placeholder="请输入"
                  maxlength="11"
                  style="width: 187px"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="微信号：" style="margin-left: 40px; width: 44%">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.weChat"
                  placeholder="请输入"
                  style="width: 187px"
                ></el-input>
              </div>
            </el-form-item>
          </div>
          <div style="display: flex; flex-direction: column; margin-bottom: 8px">
            <el-form-item
              label="所在地区："
              prop="userCountry"
              :rules="[
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rules, value, callback) =>
                    validatorEnumsLabel(rules, value, callback),
                  trigger: 'blur',
                  required: true
                }
              ]"
            >
              <CascaderArea
                :country="usersForm.userCountry"
                :province="usersForm.userProvince"
                :city="usersForm.userCity"
                class="CascaderArea"
                @searchArae="searchAraeUsers"
              />
            </el-form-item>
            <span
              style="color: #f56c6c; line-height: 22px; margin-left: 100px"
              v-if="!usersForm.userCountry || !usersForm.userProvince || !usersForm.userCity"
              >{{ msgAddressTips }}</span
            >
          </div>
          <div style="display: flex; justify-content: space-between">
            <el-form-item label="默认密码：" style="width: 50%; color: rgba(249, 138, 35, 1)">
              admin
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUsers">保 存</el-button>
        <el-button @click="edithandleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CascaderArea from '@/components/CascaderArea.vue'
import { getById, update } from '@/api/jingyiUsers.js'
import DicButton from '@/components/DicButton.vue'
export default {
  data() {
    return {
      //添加用户表单
      usersForm: {
        userCode: this.id, //用户编码
        userType: null, //用户类型：0 个人用户 1 企业用户
        companyName: '', //企业名称
        name: '', //用户名
        phone: '', //联系电话
        state: '', //是否启用: 0 停用 1启用
        nameEnglish: '', //英文名
        weChat: '', //微信号
        userCountry: '', //所在国家
        userProvince: '', //所在省份
        userCity: '', //所在城市
        mail: '', //邮箱
        gender: '' //性别
      },
      // 展示数据表单
      formData: {
        bankCar: '', //银行卡号
        businessLicense: '', //营业执照
        companyName: '', //企业名称
        contacts: '', //联系人
        createName: '', //创建人名字
        createTime: '', //创建时间/提交时间
        headPortrait: '', //头像
        idCardFront: '', //身份证正面
        idCardReverse: '', //身份证反面
        interested: '', //感兴趣领域
        mail: '', //邮件
        name: '', //姓名
        openingBank: '', //开户行支行
        phone: '', //联系电话
        rejectReason: '', //拒绝理由
        state: '', //目前状态: 0 停用 1启用
        technique: '', //擅长领域
        updateName: '', //修改人名字
        updateTime: '', //修改时间
        userCountry: '', //所在国家
        userProvince: '', //所在省份
        userCity: '', //所在城市
        userCode: '', //菁亿用户编号
        userType: '', //用户类型：0 个人用户 1 企业用户
        weChat: '' //微信号
      },
      dialogVisibleedit: false, //编辑用户弹窗
      //添加用户表单校验
      usersFormRules: {
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确联系电话', trigger: 'blur' }
        ],
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        mail: [{ required: true, message: '请输入邮箱', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      msgAddressTips: '', //所在地区提示
      idCardFrontList: [],
      idCardReverseList: []
    }
  },
  components: {
    DicButton,
    CascaderArea
  },
  computed: {
    // 用户唯一id
    id() {
      return this.$route.query.userCode
    },
    reviewStatus() {
      return this.$route.query.reviewStatus
    }
  },
  created() {
    this.getById()
  },
  methods: {
    // 返回上级
    backSuperior() {
      this.$router.push({
        path: '/jingyiUsers'
      })
    },
    // 查看单个数据
    async getById() {
      const { data } = await getById({ userCode: this.id })
      if (data.resultCode == 200) {
        this.formData = data.data
        this.usersForm.userType = data.data.userType
        this.usersForm.name = data.data.name
        this.usersForm.phone = data.data.phone
        this.usersForm.state = data.data.state
        this.usersForm.companyName = data.data.companyName
        this.usersForm.weChat = data.data.weChat
        this.usersForm.gender = data.data.gender
        this.usersForm.nameEnglish = data.data.nameEnglish
        this.usersForm.userCountry = data.data.userCountry
        this.usersForm.userProvince = data.data.userProvince
        this.usersForm.userCity = data.data.userCity
        this.usersForm.mail = data.data.mail

        this.idCardFrontList.push(data.data.idCardFront)
        this.idCardReverseList.push(data.data.idCardReverse)
      }
    },
    //编辑 弹框显示
    editItem() {
      // this.$router.push({
      //   path: '/dataManagement/addEnterprise',
      //   query: {
      //     enterpriseType: 0,
      //     searchInfo: JSON.stringify(this.queryInfo)
      //   }
      // })
      this.dialogVisibleedit = true
      // this.$emit('editItem', res.data')
      // this.addProjectDialogShow = true
      // this.currentErpriseName = ''
      // this.positionList = []
    },
    // 编辑 弹窗关闭
    edithandleClose() {
      this.dialogVisibleedit = false
      this.getById()
    },
    //编辑
    editUsers() {
      this.$refs.usersForm.validate(async (valid) => {
        if (valid) {
          this.usersForm.userCode = this.id
          const { data } = await update(this.usersForm)
          if (data.resultCode == 200) {
            this.$message.success(data.message)
            this.dialogVisibleedit = false
            this.getById()
          }
        }
      })
    },
    // 弹窗选择所在地区赋值
    searchAraeUsers(val) {
      this.usersForm.userCountry = val.country
      this.usersForm.userProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.usersForm.userCity = val.city
      }
      if (val) {
        this.msgAddressTips = ''
      }
    },
    //所在地区校验
    validatorEnumsLabel(rules, value, callback) {
      if (!this.usersForm.userCountry || !this.usersForm.userProvince) {
        this.msgAddressTips = '请选择所在地区'
      } else {
        this.msgAddressTips = ''
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-input__inner {
  border: none;
}
.usersDetail {
  font-family: PingFang SC;
}
.reasonState {
  margin-top: 10px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid rgba(250, 80, 80, 1);
  background: rgba(250, 80, 80, 0.15);
  border: 1px solid rgba(250, 80, 80, 1);
  color: rgba(250, 80, 80, 1);
  font-size: 14px;
  span {
    padding-left: 6px;
  }
}
.userInfoTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  .user_left {
    font-family: PingFang SC;
    display: flex;
    justify-content: space-between;
    img {
      width: 88px;
      height: 88px;
      margin-right: 10px;
      border-radius: 4px;
    }
    .userInfo {
      padding: 4px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3 {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        text-align: left;
        color: rgba(26, 31, 51, 1);
      }
      .stateBox {
        display: flex;
        align-items: center;
      }
      .phone {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.6px;
        text-align: left;
        color: rgba(51, 51, 51, 1);
      }
      .state {
        width: 32px;
        height: 18px;
        border-radius: 9px;
        font-size: 10px;
        margin-left: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .stateQ {
        background: #f0f9eb;
        color: #67c23a;
      }
      .stateT {
        background: #f4f4f5;
        color: #333;
      }
    }
  }
  .user_right {
    display: flex;
    margin-right: 40px;
    .el-button--success.is-plain {
      color: rgba(23, 117, 122, 1);
      background: #fff;
      border-color: rgba(23, 117, 122, 1);
    }
  }
}
.userInfoBom {
  overflow: auto;
  margin-top: 14px;
  background: #fff;
  padding: 20px 20px 40px 20px;
  border-radius: 10px;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: center;
    span:nth-child(1) {
      display: block;
      width: 4px;
      height: 20px;
      background: rgba(23, 117, 122, 1);
      border-radius: 4px;
      margin-right: 6px;
    }
    span:nth-child(2) {
      font-size: 16px;
      font-weight: 500;
      line-height: 22.4px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .infoDetail {
    padding: 20px 50px;
    display: flex;
    img {
      width: 124px;
      height: 84px;
    }
    div {
      width: 50%;
    }
    .el-form-item {
      font-size: 14px;
      font-weight: 400;
      line-height: 19.6px;
      color: rgba(26, 31, 51, 1);
    }
  }
  .account {
    display: flex;
    flex-direction: column;
  }
  .commitTime {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: rgba(153, 153, 153, 1);
    padding: 10px 0 0 50px;
    span {
      padding: 6px 0;
    }
  }
}
.operation {
  padding: 20px 0;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  .el-button--primary {
    color: rgba(23, 117, 122, 1) !important;
    background: #fff !important;
    border-color: rgba(23, 117, 122, 1) !important;
    margin-right: 20px;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
.auditingNo {
  .title {
    display: flex;
    align-items: center;
  }

  span:nth-child(1) {
    display: block;
    width: 4px;
    height: 20px;
    background: rgba(23, 117, 122, 1);
    border-radius: 4px;
    margin-right: 6px;
  }
  span:nth-child(2) {
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    color: rgba(51, 51, 51, 1);
  }
}

.el-button--text:focus {
  border: 1px solid #fff !important;
}
.el-button--text:hover {
  border: 1px solid #fff !important;
}
.row {
  display: flex !important;
  flex-direction: row !important;
}

.empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 308px;
    height: 300px;
    margin-bottom: 16px;
  }
}
</style>
